var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8D057",
    d: "M20.923 10.461c0 5.778-4.684 10.462-10.461 10.462C4.683 20.923 0 16.24 0 10.462S4.684 0 10.461 0s10.462 4.684 10.462 10.461"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "m10.65 5.699 4.312 4.287a.67.67 0 0 1 0 .952l-4.311 4.287a.68.68 0 0 1-.958 0 .67.67 0 0 1 0-.952l3.155-3.137H6.806V9.788h6.042L9.693 6.651a.67.67 0 0 1 0-.952.68.68 0 0 1 .958 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "M5.763 10.462c0-.433.263-.783.587-.783h6.658c.324 0 .587.35.587.783s-.263.783-.587.783H6.35c-.324 0-.587-.35-.587-.783",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;